import Vue from 'vue'
import VideoPlayer from './VideoPlayer.vue'

const VideoPlayerComponent = Vue.extend(VideoPlayer)
let vp = new VideoPlayerComponent()
vp.$mount()

global.videoPlayer = {
    play: source => {
        document.body.appendChild(vp.$el)
        vp.url = source.url
        vp.visible = true
    }
}


// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js